import React from 'react';
import { Button } from './ui/button';
import './ErrorBoundary.css';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null, 
      errorInfo: null,
      showDetails: false 
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({
      error,
      errorInfo
    });
    
    // Log to error reporting service (e.g., Sentry) here if needed
  }

  handleReset = () => {
    this.setState({ 
      hasError: false, 
      error: null, 
      errorInfo: null,
      showDetails: false 
    });
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      const isGerman = navigator.language?.startsWith('de');
      
      return (
        <div className="error-boundary-container">
          <div className="error-boundary-content">
            <div className="error-icon">⚠️</div>
            <h1>{isGerman ? 'Oops! Etwas ist schiefgelaufen' : 'Oops! Something went wrong'}</h1>
            <p className="error-message">
              {isGerman 
                ? 'Es tut uns leid, aber die Anwendung ist auf einen Fehler gestoßen. Bitte versuchen Sie, die Seite neu zu laden.'
                : 'We\'re sorry, but the application encountered an error. Please try reloading the page.'}
            </p>
            
            <div className="error-actions">
              <Button onClick={this.handleReset} className="error-button">
                {isGerman ? '🏠 Zur Startseite' : '🏠 Go to Home'}
              </Button>
              <Button 
                onClick={() => window.location.reload()} 
                variant="outline"
                className="error-button"
              >
                {isGerman ? '🔄 Seite neu laden' : '🔄 Reload Page'}
              </Button>
            </div>

            <button 
              className="error-details-toggle"
              onClick={() => this.setState({ showDetails: !this.state.showDetails })}
            >
              {this.state.showDetails 
                ? (isGerman ? '▼ Details ausblenden' : '▼ Hide Details') 
                : (isGerman ? '▶ Details anzeigen' : '▶ Show Details')}
            </button>

            {this.state.showDetails && (
              <div className="error-details">
                <h3>{isGerman ? 'Fehlerdetails:' : 'Error Details:'}</h3>
                <pre className="error-stack">
                  {this.state.error && this.state.error.toString()}
                  {this.state.errorInfo && this.state.errorInfo.componentStack}
                </pre>
              </div>
            )}

            <p className="error-help">
              {isGerman ? 'Wenn das Problem weiterhin besteht, kontaktieren Sie uns unter ' : 'If the problem persists, please contact us at '}
              <a href="mailto:info@storytales.xyz">info@storytales.xyz</a>
            </p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
